<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="系统编号">
              <a-input v-model="queryParam.number" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="采销全流程">
              <a-select
                show-search
                allow-clear
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                v-model="queryParam.project_id"
                placeholder="请输入名称"
                @search="this.projectSearch"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="合同号">
              <a-input v-model="queryParam.contract_number" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="担保方式">
              <a-select
                allow-clear
                placeholder="选择"
                v-model="queryParam.guarantee_method"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.guarantee_method">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24" v-if="false">
            <a-form-item label="创建人">
              <a-input v-model="queryParam.create_by" placeholder="创建人" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="false">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleArchived">批量存档</a-button>
            </span>
          </a-col>
          <a-col :md="4" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1200 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="approval_needed" slot-scope="text, item">
        <a-popconfirm
          title="确定开启审批吗?"
          :disabled="text"
          @confirm="() => approvalNeeded(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
        </a-popconfirm>
      </span>
      <span slot="archived" slot-scope="text, item">
        <a-popconfirm
          title="确定存档吗?"
          :disabled="text"
          @confirm="() => archived(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
        </a-popconfirm>
      </span>
      <span slot="reportData" slot-scope="text">
        <span v-for="(value, key, index) in text" :key="index">
          {{ key }}: {{ value }} {{ index === Object.entries(text).length - 1 ? '' : ',' }}
        </span>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleWatchView(record)">预览</a>
          <a-divider type="vertical"/>
          <a @click="handleEdit(record)" v-if="!record.is_archived">编辑</a>
          <a-divider type="vertical" v-if="!record.is_archived"/>
          <a-popconfirm
            v-if="!record.is_archived"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="!record.is_archived"/>
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleAttachment(record)">附件</a>
              </a-menu-item>
              <a-menu-item v-if="record.version > 1">
                <a @click="handleModifyRecord(record)">查看修改</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleCopy(record)">复制合同</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>
    <contract-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <guarantee-contract-record :contract="mdl" :visible="recordVisible" @close="recordVisible=false" v-if="recordVisible"/>
    <watch-view-form :model="mdl" :visible="watchViewVisible" @cancel="watchViewVisible=false" v-if="watchViewVisible"/>
  </div>
</template>

<script>
import { STable } from '@/components'
import ContractForm from '../modules/ContractForm'
import WatchViewForm from '../modules/WatchViewForm'
import GuaranteeContractRecord from '../../project/modules/GuaranteeContractRecord'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'
import {
  goods_report_archived, goods_report_create, goods_report_delete,
  goods_report_list
} from '@/api/trade_report'

export default {
  name: 'TableList',
  components: {
    STable,
    ContractForm,
    GuaranteeContractRecord,
    WatchViewForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      approval_again: false,
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archivedVisible: false,
      recordVisible: false,
      watchViewVisible: false,
      projectFetching: false,
      projectList: [],
      mdl: {},
      // 查询参数
      queryParam: {
        filter: true
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '系统编号',
          dataIndex: 'number',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 180,
          ellipsis: true
        },
        {
          title: '报告类型',
          dataIndex: 'report_type',
          width: 150,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_goods_report_types[text] || ''
        },
        {
          title: '报告主要内容',
          dataIndex: 'report_data',
          width: 180,
          ellipsis: true,
          scopedSlots: { customRender: 'reportData' }
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 180,
          ellipsis: true
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return goods_report_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],
      optionAlertShow: false
    }
  },
  created () {
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  methods: {
    handleAdd () {
      const date = new Date()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      this.mdl = { number: date.getFullYear() + '' + (date.getMonth() + 1) + date.getDate() + hours + minutes }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archivedVisible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleCopy (record) {
      this.$router.push({ path: '/trade/report/' + record.id + '/copy' })
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/report/' + record.id })
    },
    handleAttachment (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/report/' + record.id + '/attachment', query: { record: record.name } })
    },
    handleWatchView (record) {
      this.mdl = record
      this.watchViewVisible = true
    },
    handleDelete (record) {
      goods_report_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleModifyRecord (record) {
      // 查看修改记录
      this.mdl = record
      this.recordVisible = true
    },
    approvalNeeded (record) {
      console.log(record)
    },
    archived (record) {
      goods_report_archived({ id: record.id, is_archived: !record.is_archived }).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          this.confirmLoading = true
          data['json_data'] = undefined
          const commitData = this.joinData(values, data)
          goods_report_create(commitData).then(res => {
            if (res.code === 1000) {
              // 刷新表格
              this.$refs.table.refresh()
              this.visible = false
              // 重置表单数据
              form.resetFields()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    joinData (values, data) {
      const newData = {
        project_id: values['project_id'],
        number: values['number'],
        report_type: values['report_type'],
        report_data: data['report_data'],
        attachment: data['attachment']
      }
      return newData
    }
  }
}
</script>
